import React, { useRef, useContext, useLayoutEffect } from "react";
import { useFullscreen } from "react-use";
import ThemeContext from "../../Contexts/themeContext";
import Wrapper from "./Wrapper";
import { REACT_APP_MODERN_DESGIN } from "../../Utils/Constant";
import Aside from "./Aside/Aside";

const FrameLayout = ({ children }) => {
  /**
   * Full Screen
   */
  const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
  const ref = useRef(null);
  useFullscreen(ref, fullScreenStatus, {
    onClose: () => setFullScreenStatus(false),
  });

  /**
   * Modern Design
   */
  useLayoutEffect(() => {
    if (REACT_APP_MODERN_DESGIN == true) {
      document.body.classList.add("modern-design");
    } else {
      document.body.classList.remove("modern-design");
    }
  });

  return (
    <div
      ref={ref}
      className="app"
      style={{
        backgroundColor: fullScreenStatus ? "var(--bs-body-bg)" : undefined,
        zIndex: fullScreenStatus ? 1 : undefined,
        overflow: fullScreenStatus ? "scroll" : undefined,
      }}
    >
      {/* For Sidebar */}
      <Aside />

      {/* For Header and Content */}
      <Wrapper children={children} />
    </div>
  );
};
export default FrameLayout;
